// extracted by mini-css-extract-plugin
export default {"userData":"styles_userData__Wg8IP","popover":"styles_popover__zcYKT"};